import { render, staticRenderFns } from "./AGPSClosure.vue?vue&type=template&id=34597bb9"
import script from "./AGPSClosure.vue?vue&type=script&lang=js"
export * from "./AGPSClosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports